import React from "react";
import { DisplayComponent } from "scmp-sdk/components/newsletter/newsletter-widget/enums";
import { StyledSignUpNewsletter } from "scmp-sdk/components/newsletter/newsletter-widget/styles";
import type { NewsletterHook } from "scmp-sdk/components/newsletter/newsletter-widget/types";

export const useArticleRender: NewsletterHook = onSuccess => ({
  [DisplayComponent.SignUpNewsletter]: props => (
    <StyledSignUpNewsletter isShowOverlaySignUp onSuccess={onSuccess} {...props} />
  ),
});
